import { defineAsyncComponent, h } from "vue";
import { ElNotification } from "element-plus";
import { faCircleCheck, faCircleExclamation } from "@awesome.me/kit-bda1b4ada1/icons/classic/solid";
import { gettext } from "@/services/translation";

// Intentionally not useAsyncComponent: this is the fallback UI shown when a dynamic import fails, so
// its own icon/button must not depend on the same retry machinery it is reporting a failure for.
const Icon = defineAsyncComponent(() => import("@/components/basics/Icon.vue"));
const Button = defineAsyncComponent(() => import("@/components/basics/Button.vue"));

const Position = "bottom-left";
const Duration = 5000;

export const showSuccessToast = (message: string) => {
  ElNotification({
    message,
    icon: h(Icon, { icon: faCircleCheck }),
    customClass: "success",
    position: Position,
    duration: Duration,
  });
  const liveRegion = document.getElementById("toast-live-region");
  if (liveRegion) {
    liveRegion.textContent = message;
    setTimeout(() => {
      liveRegion.textContent = "";
    }, 1000);
  }
};

export const showErrorToast = (message: string) => {
  ElNotification({
    message,
    customClass: "error",
    icon: h(Icon, { icon: faCircleExclamation }),
    position: Position,
    duration: Duration,
  });
};

/**
 * For a failure the collector can do nothing about but try again — the wording was repeated in every
 * second catch block. Translated at call time, so it follows the language that is active then.
 */
export const showGenericErrorToast = () => {
  showErrorToast(gettext.$gettext("Akci se nepodařilo provést. Zkus to prosím znovu."));
};

/**
 * Non-destructive last resort for an exhausted dynamic-import retry: stays open until dismissed and
 * lets the user decide when it's safe to reload, instead of an automatic location.reload() that would
 * silently discard in-progress input.
 */
export const showReloadToast = (message: string, reloadLabel: string) => {
  ElNotification({
    message: () => h("div", { class: "reload-toast" }, [h("p", { class: "reload-toast__text" }, message), h(Button, { class: "reload-toast__action", onClick: () => window.location.reload() }, { default: () => reloadLabel })]),
    customClass: "error",
    icon: h(Icon, { icon: faCircleExclamation }),
    position: Position,
    duration: 0,
  });
};
